import { render } from "./GroupsView.vue?vue&type=template&id=2601b981"
import script from "./GroupsView.vue?vue&type=script&lang=js"
export * from "./GroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__